import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/internal-compatibility';
import { switchMap, tap } from 'rxjs/operators';
import {
  IAddressDistanceParams,
  IAddressDistanceResponse,
  IGeoCodingAddressDetailResult,
  IGeoCodingSuggestionResult
} from './address.model';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  constructor(private httpClient: HttpClient) { }

  private readonly apiEndPoint = '/api/Address';

  lat: number;
  long: number;

  public getAddressDistance(adressDistanceParams: IAddressDistanceParams): Observable<IAddressDistanceResponse> {
    return this.httpClient.get<IAddressDistanceResponse>(
      `${this.apiEndPoint}/Distance?originAddressId=` +
      adressDistanceParams.originAddressId +
      `&destinationAddressId=` +
      adressDistanceParams.destinationAddressId +
      `&businessUnitId=` +
      adressDistanceParams.businessUnitId +
      `&serviceTypeId=` +
      adressDistanceParams.serviceTypeId
    );
  }

  public getGeoCodingAddressSuggestions(query: string): Observable<IGeoCodingSuggestionResult> {
    const categoryQueryString = 'category=Street Address,Point Address,Intersection';
    const sourceCountryQueryString = 'sourceCountry=CAN';

    let locationQueryString;

    return fromPromise(this.getCurrentLocationCoordinates()).pipe(
      tap(m => {
        locationQueryString = this.lat ? `location=${this.long},${this.lat}` : '';
      }),
      switchMap(t => {
        return this.httpClient.get<IGeoCodingSuggestionResult>(
          `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest` +
          `?text=${query}&${categoryQueryString}&${sourceCountryQueryString}&${locationQueryString}&f=pjson`
        );
      })
    );
  }

  public getAddressDetails(magicKey: string): Observable<IGeoCodingAddressDetailResult> {
    return this.httpClient.get(`/api/AuthorizationGroups/MapsAuth`, { responseType: 'text' }).pipe(
      switchMap(token => {
        return this.httpClient.get<IGeoCodingAddressDetailResult>(
          `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/` +
          `findAddressCandidates?outFields=*&magicKey=${magicKey}&token=${token}&f=pjson`
        );
      })
    );
  }

  getCurrentLocationCoordinates() {
    return new Promise<void>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resp => {
          this.lat = resp.coords.latitude;
          this.long = resp.coords.longitude;

          resolve();
        },
        err => {
          resolve();
        }
      );
    });
  }
}
